<template>
  <div>
    <collapse title="Renovación del contrato">
      <div class="row">
        <div class="col-12 col-md">
          <label class="data-label">
            El artículo 19 de la Guía estable que las renovaciones de contratos
            cuyos servicios hayan sido procurados mediante procesos competitivos
            podrán realizarse por un período de hasta cinco años
          </label>
          <validation-provider v-slot="{ validated }" rules="required">
            <custom-radio
              v-model="canRenewal"
              class="custom-radio"
              custom-error-msg="El campo es requerido."
              :disabled="isReadOnly"
              is-inline
              :label="'¿Los servicios podrán ser renovados?'"
              name="canRenewal"
              :options="options"
              @input="onCanRenewalChange"
            />
            <error
              v-if="validated && ![true, false].includes(canRenewal?.value)"
              message="El campo es requerido."
              variant="no-border"
            />
          </validation-provider>
        </div>
      </div>
      <div v-if="canRenewal?.value" class="row mt-3">
        <div class="col">
          <label class="">
            ¿Por cuánto tiempo?
          </label>
        </div>
      </div>
      <div v-if="canRenewal?.value" class="row">
        <div class="col-12 col-md-2">
          <validation-provider v-slot="{ errors }" rules="required|min_value:1">
            <custom-input
              id="renewalDuration"
              v-model.lazy.number="model.renewalDuration"
              custom-error-msg="El campo es requerido y debe ser mayor a 0"
              :disabled="isReadOnly"
              :error="errors[0]"
              :min="0"
              type="number"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md-2">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="renewalDurationType"
              v-model="renewalDurationType"
              :clearable="false"
              custom-error-msg="El campo es requerido"
              :disabled="isReadOnly"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="renewalDurationTypes"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
      </div>
    </collapse>
  </div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import Collapse from '@/components/common/SimpleCollapse.vue';
import CustomRadio from 'custom-radio';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import Error from 'custom-error';

import DurationTypes from '@/utils/constants/contractRenewalDurationTypes';

extend('afterStartDate', {
  params: ['start'],
  validate(value, { start }) {
    if (!value || !start) return true;
    return new Date(value) > new Date(start);
  },
  message: 'La fecha de finalización debe ser posterior a la fecha de inicio.',
});

export default {
  name: 'ContractRenewal',
  components: {
    Collapse,
    ValidationProvider,
    CustomRadio,
    Error,
    CustomDropDown,
    CustomInput,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {};
  },
  computed: {
    canRenewal: {
      get() {
        const value = this.options.find(
          (x) => x.value === this.model.canRenewal
        );

        return value ?? {};
      },
      set(option) {
        this.model.canRenewal = option?.value;
      },
    },
    renewalDurationType: {
      get() {
        const value = this.renewalDurationTypes.find(
          (x) => x.id === this.model.renewalDurationType
        );
        return value ?? this.renewalDurationTypes[0];
      },
      set(option) {
        this.model.renewalDurationType = option?.id;
      },
    },
    options() {
      return [
        {
          id: 1,
          name: 'yes',
          label: 'Si',
          value: true,
        },
        {
          id: 2,
          name: 'no',
          label: 'No',
          value: false,
        },
      ];
    },
    renewalDurationTypes() {
      return DurationTypes;
    },
  },
  methods: {
    onCanRenewalChange(val) {
      this.model.renewalDuration = null;
      this.model.renewalDurationType = val?.value ? 1 : null;
    },
  },
};
</script>
<style scoped>
.custom-radio ::v-deep .col-12 {
  padding: 0 !important;
}
.custom-font {
  color: #727272;
  font-size: 14px;
}
::v-deep .custom-datetime-picker-container {
  width: 100% !important;
  input[type='text'] {
    width: 100%;
  }
}
</style>
